<div [formGroup]="formGroup">
  <sc-select-field formControlName="gate" labelDictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.gate"
    [data]="options"></sc-select-field>
</div>
